<template>
  <section class="section" id="refills-stock-section">
    <div class="container">
      <b-loading :is-full-page="true" :active="isLoading" :can-cancel="false" />

      <refills-stock-title
        @search="getRefillsStock"
        @download="downloadRefillsStockReport"
        @update-store="storeId = $event"
        @update-barcode="barcode = $event"
        @update-refills="refillsOperations = $event"
      />

      <p v-if="productName" class="product-title">{{ productName }}</p>
      <refills-stock-table :refill-stocks="refillsStock" />
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import refillsStockTitle from "./RefillsStockTitle";
import refillsStockTable from "./RefillsStockTable";

export default {
  mixins: [common],
  components: { refillsStockTitle, refillsStockTable },
  data() {
    return {
      isLoading: false,
      storeId: "",
      barcode: "",
      refillsOperations: 2,
      refillsStock: [],
      productName: ""
    };
  },
  methods: {
    requestData(action) {
      if (!this.storeId) {
        this.alertError({ message: "STORE_REQUIRED" });
        return Promise.resolve();
      }
      if (!this.barcode) {
        this.alertError({ message: "BARCODE_REQUIRED" });
        return Promise.resolve();
      }
      if (
        !Number.isInteger(Number(this.refillsOperations)) ||
        Number(this.refillsOperations) < 1 ||
        Number(this.refillsOperations) > 10
      ) {
        this.alertError({ message: "INVALID_REFILLS_OPERATIONS" });
        return Promise.resolve();
      }
      if (action === "downloadRefillsStockReport") {
        if (!this.refillsStock.length) {
          this.alertError({ message: "NO_PRODUCT_LOGS_TO_EXPORT" });
          return Promise.resolve();
        }
        return this.download();
      }
      this.isLoading = true;
      return this.$store
        .dispatch(action, {
          storeId: this.storeId,
          barcode: this.barcode,
          refillsOperations: this.refillsOperations
        })
        .then(res => {
          if (action === "getRefillsStock") {
            if (res.data.result === "error") {
              this.alertError(res.data);
            } else {
              this.refillsStock = res.data.payload.refillsStock;
              this.productName = res.data.payload.productName;
            }
          }
        })
        .catch(() => this.alertError({ message: "UNEXPECTED_ERROR" }))
        .finally(() => {
          this.isLoading = false;
        });
    },
    getRefillsStock() {
      return this.requestData("getRefillsStock");
    },
    downloadRefillsStockReport() {
      return this.requestData("downloadRefillsStockReport");
    },
    download() {
      return this.$store.dispatch("downloadRefillsStockReport", {
        refillsStock: this.refillsStock,
        productName: this.productName
      });
    }
  }
};
</script>

<style scoped>
#refills-stock-section {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
.product-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
</style>
